import React from 'react';
import cn from 'classnames';
import { idxMap } from 'helpers/styleMapIdx';

import styles from './Switch.module.scss';

const SIZES = {
  lg: styles.switchLarge,
  sm: styles.switchSmall,
};

const Switch = ({
  className,
  readOnly,
  disabled,
  size,
  ...restProps
}: { className: any; readOnly: any; disabled: any; size: any } & Record<
  string,
  any
>) => (
  <div
    className={cn(
      styles.switch,
      idxMap(SIZES as Record<string, string>, size),
      { [styles.switchDisabled]: disabled, [styles.switchReadOnly]: readOnly },
      className,
    )}
    tabIndex={-1}
  >
    <input type="checkbox" className={styles.field} {...restProps} />
    <div className={styles.body} />
    <div className={styles.toggle} />
  </div>
);

Switch.defaultProps = {
  size: 'lg',
};

export default React.memo(Switch) as any;
